import React, { useCallback, useEffect, useMemo, useState } from "react";
import {Row, Col, Input, Select, DatePicker, TimePicker } from "antd";
import { useSelector } from "react-redux";
import moment from "moment";

import {
  calculateBusinessDays,
  disabledDate,
  disabledHours,
  disabledMinutes,
  durationMinutes,
  addMinutesToTime,
  resourceTypes,
} from "../../../utils/CommonFunctions";

import styles from "../../../styles/sass/searchresult.module.scss";

const locationSVG = "/assets/images/nw_i_black.svg";
const durationSVG = "/assets/images/nw_i_black_t_z.svg";
const calendarSVG = "/assets/images/nw_i_black_calender.svg";
const capacitySVG = "/assets/images/nw_i_black_user.svg";
const resourceSVG = "/assets/images/nw_i_black_desk.svg";
const clockSVG = "/assets/images/nw_i_black_clock.svg";

const ResourceFilterHeader = ({
  workspace,
  resource_type,
  capacity,
  from_to_date,
  from_date,
  from_time,
  onSearch = () => {},
  filter,
  handleChange = (value) => value,
  showOnlyResources = [
    "meeting_room",
    "flexi_desk",
    "dedicated_desk",
    "private_office",
  ],
  ...props
}) => {
  const [dropDown, setDropdown] = useState(false);
  const [checkAllConditions, setCheckAllConditions] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const { activeWorkspaceList, workSpaceMap } = useSelector(
    ({ workspace }) => workspace
  );
  const selectedWorkspace = workSpaceMap?.[workspace];

  const options = useMemo(
    () =>
      activeWorkspaceList?.map((s_id) => ({
        _id: s_id,
        value: workSpaceMap[s_id]?.name,
      })),
    [activeWorkspaceList]
  );

  const getDuration = useCallback(() => {
    if ((resource_type !== "meeting_room" && props?.to_date, from_date)) {
      return calculateBusinessDays(
        from_date,
        props?.to_date,
        selectedWorkspace?.no_of_days
      );
    }
  }, [from_date, props?.to_date, resource_type, selectedWorkspace?.no_of_days]);


  useEffect(() => {
    const office_hours_start = selectedWorkspace?.office_hours?.[0];
    const office_hours_end = selectedWorkspace?.office_hours?.[1];
    const startDateTime = moment(office_hours_start).format("HH:mm:ss");
    const endDateTime = moment(office_hours_end).format("HH:mm:ss");
    const durationMinutesData = durationMinutes(props?.duration);
    const minutes = durationMinutesData * 60;
    const initialTime = moment(from_time);
    //const newTime = initialTime.subtract(1, "hours");
    const selectTime = initialTime.format("HH:mm:ss");
    const case1 =
      resource_type === "meeting_room" &&
      from_date !== null &&
      from_time !== null &&
      addMinutesToTime(selectTime) < addMinutesToTime(startDateTime);

    const case2 =
      resource_type === "meeting_room" &&
      from_date !== null &&
      from_time !== null &&
      addMinutesToTime(selectTime, minutes) > addMinutesToTime(endDateTime);

    if (case1) {
      setCheckAllConditions(true);
    } else if (case2) {
      setCheckAllConditions(true);
    } else {
      setCheckAllConditions(false);
    }
  }, [selectedWorkspace?.office_hours, resource_type, from_date, from_time, props?.duration]);

  useEffect(() => {
    const office_hours_start = selectedWorkspace?.office_hours?.[0];
    const office_hours_end = selectedWorkspace?.office_hours?.[1];
    const startDateTime = moment(office_hours_start).format("hh:mm A");
    const endDateTime = moment(office_hours_end).format("hh:mm A");
    const msg = `Our workspace is open from ${startDateTime} to ${endDateTime}. Please contact info@go-bermondsey.co.uk for assistance with bookings outside these hours.`;
    setErrorMsg(msg);
  }, [selectedWorkspace?.office_hours, resource_type, from_time, from_date]);

return (
    <>
    {checkAllConditions && (
          <Row align="middle" className="book-form-spacerBottom">
            <Col span={24} style={{ color: "red", textAlign: "center" }}>
              {errorMsg}
            </Col>
          </Row>
        )}  
    <div
      className={`${styles["resource-header"]} ${
        dropDown ? styles["activeDD"] : ""
      }`}
    >
      
      <div className={`${styles["rh_option"]}`}>
        <p>LOCATION</p>
        <img src={locationSVG} alt="location-logo"></img>
        <Select
          dropdownClassName="custom-select-dropdown"
          bordered={false}
          placeholder={"Select Location"}
          value={workspace}
          onChange={handleChange("workspace")}
          placement={"bottomRight"}
          dropdownMatchSelectWidth={false}
        >
          {options?.map((option) => (
            <Select.Option key={option?._id} value={option?._id}>
              {option?.value}
            </Select.Option>
          ))}
        </Select>
      </div>
      <div className={styles["rh_option"]}>
        <p>
          DURATION {`(${resource_type === "meeting_room" ? "Hours" : "Days"})`}
        </p>
        <div className={`${styles["dis_flex"]} ${styles["duration"]}`}>
          <img src={durationSVG} alt="sandwatch-logo"></img>
          {resource_type === "meeting_room" ? (
            <Input
              type="number"
              min={1}
              step={0.5}
              value={props?.duration}
              onChange={handleChange("duration")}
              bordered={false}
            />
          ) : (
            <span>{getDuration()}</span>
          )}
        </div>
      </div>

      <div className={`${styles["rh_option"]} `}>
        <p>DATE</p>

        {resource_type === "meeting_room" ? (
          <>
            <img src={calendarSVG} alt="location-logo"></img>
            <DatePicker
              dropdownClassName="custom-calender-conteiner"
              value={from_date}
              onChange={handleChange("from_date")}
              disabledDate={disabledDate({
                activeDays: selectedWorkspace?.no_of_days,
              })}
              bordered={false}
              clearIcon={true}
              allowClear={false}
              suffixIcon={null}
              placement={"bottomRight"}
              showToday={false}
              inputReadOnly={true}
            />

            <img src={clockSVG} alt="clock-icon" />

            <TimePicker
              style={{ paddingLeft: 10, width: "40%", marginRight: 0 }}
              popupClassName="custom-time-picker-container"
              value={from_time}
              onSelect={handleChange("from_time")}
              format="HH:mm"
              minuteStep={5}
              disabledHours={() => disabledHours(selectedWorkspace, from_date)}
              disabledMinutes={() => disabledMinutes(from_date, from_time)}
              suffixIcon={null}
              bordered={false}
              showNow={false}
              inputReadOnly={true}
              hideDisabledOptions={true}
              allowClear={false}
            />
          </>
        ) : (
          <>
            <img src={calendarSVG} alt="location-logo"></img>
            <DatePicker
              className={styles["data_c_c_b"]}
              dropdownClassName="custom-calender-conteiner"
              bordered={false}
              placeholder="Start date"
              value={from_date}
              onChange={handleChange("from_date")}
              disabledDate={disabledDate({
                activeDays: selectedWorkspace?.no_of_days,
              })}
              allowClear={false}
              suffixIcon={null}
              showToday={false}
              inputReadOnly={true}
            />

            <DatePicker
              className={styles["data_c_c_b"]}
              dropdownClassName="custom-calender-conteiner"
              placeholder="End date"
              bordered={false}
              value={props?.to_date}
              onChange={handleChange("to_date")}
              disabledDate={disabledDate({
                activeDays: selectedWorkspace?.no_of_days,
                toDisabledDate: moment(from_date).subtract(1, "days"),
              })}
              allowClear={false}
              suffixIcon={null}
              showToday={false}
              inputReadOnly={true}
            />
          </>
        )}
      </div>

      <div className={styles["nw_rh_option"]}>
        <p>WORKSPACE TYPE</p>
        <img src={resourceSVG} alt="desk-icon"></img>

        <Select
          dropdownClassName="custom-select-dropdown"
          placeholder="Select Resource"
          value={resource_type}
          onChange={handleChange("resource_type")}
          bordered={false}
        >
          {showOnlyResources.map(
            (r_type) =>
              resourceTypes[r_type] && (
                <Select.Option key={r_type} value={r_type}>
                  {resourceTypes[r_type]?.name}
                </Select.Option>
              )
          )}
        </Select>
      </div>
      <div className={styles["nw_rh_option"]}>
        <p>CAPACITY</p>
        <div className={styles["dis_flex"]}>
          <img src={capacitySVG} alt="capacity-icon"></img>
          <Input
            type={"number"}
            bordered={false}
            placeholder="Capacity"
            value={capacity}
            onChange={handleChange("capacity")}
          />
        </div>
      </div>
      <a onClick={onSearch} className={`${styles["modify-btn"]}  ${(checkAllConditions)? "disableButton":""}`}>
        Modify Search
      </a>
      <span
        className={styles["arrow_mob"]}
        onClick={() => {
          setDropdown(!dropDown);
        }}
      ></span>
    </div>
    </>
  );
};

export default ResourceFilterHeader;
